import { makeStore } from './store';
import { tinymceCommonOptions, tinymceExtendedOptions } from '../initTinymce';

const models = JSON.parse(JSON.stringify(J.models));
const applications = JSON.parse(JSON.stringify(J.applications));
const networks = JSON.parse(JSON.stringify(J.networks));
const platform = {
    userHighlightFields: J.userHighlightFields ? JSON.parse(JSON.stringify(J.userHighlightFields)) : undefined,
    userAccountStatus: J.userAccountStatus ? JSON.parse(JSON.stringify(J.userAccountStatus)) : undefined,
};
const hooks = JSON.parse(JSON.stringify(J.hooks));
const userCurrent = J.jUserCurrent ? JSON.parse(JSON.stringify(J.jUserCurrent)) : undefined;

export const store = makeStore({
    models,
    tinymceCommonOptions,
    tinymceExtendedOptions,
    applications,
    networks,
    platform,
    hooks,
    userCurrent,
});
